(function () {
  // snippet includes this file once per addon_by_variants block; run only once
  if (window._addonByVariantsInit) return;
  window._addonByVariantsInit = true;

  const curSelection = $("#currentSelection");

  function deselectAddOns() {
  if (window._skipGlobalDeselect) return;

    // only touch checked inputs, so an unchanged state fires no change events
    $(".addon_by_variants-container .addon input:checked").each(function () {
      $(this).prop("checked", false).trigger("change");
    });
  }

  function updateAddOnDisplay() {
      const currentVariant = $(curSelection).attr("data-variant").toString();
      const optionSelectorVariant = $(".selectedgroupsell-addon").text().trim();

      $(".addon_by_variants-container .addon").each(function () {
          
          const variantIds_string = $(this).data("main-product-variant-ids");
          
          if (variantIds_string) {
              
              const variantIds = variantIds_string.toString().split(",");
              
              if (
                  variantIds.includes(currentVariant) || (optionSelectorVariant && variantIds.includes(optionSelectorVariant))
              ) {
                  $(this).removeClass("hide");
              } else {
                  $(this).addClass("hide");
              }

          } else {
              $(this).addClass("hide");
          }

      });

      deselectAddOns();
  }
  updateAddOnDisplay();

  $(".addon_by_variants-container").each(function () {
    const addons = $(this).find(".addons");
    const productId = addons.data("product-id");
    const selectedVariantId = $(this).find(".selected_variantId");

    const options = addons.find(`input[name="addon-${productId}"]`);
    options.on("change", function () {
      if (this.checked) {
        selectedVariantId.text($(this).val());
      } else {
        selectedVariantId.text("");
      }
      options.not(this).prop("checked", false);
    });
  });

  function watchCurSelection() {
    let target = curSelection[0];

    // only react to an actual variant change. Watching every data-* attribute
    // looped with dynamic-pricing.js, which writes data-addon-total on each change event
    let observer = new MutationObserver(function (mutations) {
      const variantChanged = mutations.some(
        (mutation) => mutation.oldValue !== target.getAttribute("data-variant")
      );
      if (variantChanged) updateAddOnDisplay();
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["data-variant"],
      attributeOldValue: true,
    });
  }
  watchCurSelection();

  function updateLinks() {

  const currentSelection = $("#currentSelection").attr("data-variant");
  const bundleAddOn = $(".selectedgroupsell").text();
  const doorCloserAddOn = $(".selectedgroupsell-second").text();
  const optionSelectorAddOn = $(".selectedgroupsell-addon").text();

  // ---- collect raw addon strings (variantId OR variantId-qty)
  const warrantyAddOnItems = [];

  $(".selected_variantId").each(function () {
    const raw = $(this).text().trim();
    if (!raw) return;

    raw.split(",").forEach(function (item) {
      warrantyAddOnItems.push(item.trim());
    });
  });

  const atcButton = $("#AddToCart-button");
  const checkoutButton = $("#initateCheckout");

  let atcLink = `/cart/add?id[]=${currentSelection}`;
  let checkoutLink = `/cart/${currentSelection}:1`;

  // ---- bundle
  if (bundleAddOn) {
    atcLink += `&id[]=${bundleAddOn}`;
    checkoutLink += `,${bundleAddOn}:1`;
  }

  // ---- door closer
  if (doorCloserAddOn) {
    atcLink += `&id[]=${doorCloserAddOn}`;
    checkoutLink += `,${doorCloserAddOn}:1`;
  }

  // ---- addons (cart link keeps -qty)
  warrantyAddOnItems.forEach(function (item) {
    atcLink += `&id[]=${item}`;
  });

  // ---- option selector addon
  if (optionSelectorAddOn) {
    atcLink += `&id[]=${optionSelectorAddOn}`;
    checkoutLink += `,${optionSelectorAddOn}:1`;
  }
  // ---- addons (checkout link converts to :qty)
  warrantyAddOnItems.forEach(function (item) {
    const parts = item.split("-");
    const variantId = parts[0];
    const qty = parts.length > 1 ? Number(parts[1]) || 1 : 1;

    checkoutLink += `,${variantId}:${qty}`;
  });

  

  atcButton.attr("href", atcLink);
  checkoutButton.attr("href", checkoutLink);
}


  let variantObserverInitialized = false;

function watchSelectedVariantId() {
  if (variantObserverInitialized) return;
  variantObserverInitialized = true;

  $(".selected_variantId").each(function () {
    const target = this;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "characterData" ||
          mutation.type === "childList"
        ) {
          updateLinks();
        }
      });
    });

    observer.observe(target, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  });
}

  $(".addon-container").click(function () {
    watchSelectedVariantId();
    updateLinks();
    console.log('Read Warranty Update');
  });
  watchSelectedVariantId();
  

  /* for the option selector */
  function watchOptionSelectorAddon() {
    console.log('watch option selector addon');

      const target = $(".selectedgroupsell-addon")[0];

      if (!target) return;

      const observer = new MutationObserver(function () {
          updateAddOnDisplay();
          updateLinks();
      });

      observer.observe(target, {
          characterData: true,
          childList: true,
          subtree: true
      });
      console.log('option selector');

  }

  watchOptionSelectorAddon();
})();
